module.exports = __webpack_public_path__ + "static/media/icon-reverse-phone.5401c540.svg";